import { useEffect, useState } from "react";
import UpdateTemplateWrapper from "./updateTemplateWrapper";

export default function View() {
    return (
        <UpdateTemplateWrapper />
    )
}